import { render } from "./tshirtOrder.vue?vue&type=template&id=6403bb23"
import script from "./tshirtOrder.vue?vue&type=script&lang=js"
export * from "./tshirtOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__